const menuItems = document.querySelectorAll("[data-menu-item]");
if (menuItems.length > 0) {
  menuItems.forEach(item => {
    item.addEventListener("mouseover", function() {
      item.setAttribute("open", "")
    });
    item.addEventListener("mouseleave", function() {
      item.removeAttribute("open");
    });
  })
};

const aboutMenuItem = document.querySelector(".mega-menu-item");
if (aboutMenuItem) {
  aboutMenuItem.addEventListener("mouseover", function() {
    aboutMenuItem.classList.add("active");
  });
  aboutMenuItem.addEventListener("mouseleave", function() {
    aboutMenuItem.classList.remove("active");
  });
}